import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { sortBy } from 'lodash';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-add-container',
  templateUrl: './add-container.component.html',
  styleUrls: ['./add-container.component.scss'],
})
export class AddContainerComponent implements OnInit, OnDestroy {
  @Input() containers: any = [];
  @Output() cancel: EventEmitter<any> = new EventEmitter<any>();
  @Output() add: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('addContainer') addContainer: ElementRef;
  modalFileRef: NgbModalRef;
  title: string = 'Add Container';
  private destroy$: Subject<any> = new Subject();
  addedConainersIndex: any = [];
  saving: boolean = false;

  constructor(
    private modalService: NgbModal,
  ) {}

  ngOnInit(): void {}

  openModal() {
    this.modalFileRef = this.modalService.open(this.addContainer, {
      centered: true,
      size: 'lg',
      keyboard: false,
      backdrop: 'static',
    });
  }

  onCheckChange(event, index) {
    if (event.checked) {
      this.addedConainersIndex.push(index);
    } else {
      this.addedConainersIndex.splice(this.addedConainersIndex.indexOf(index), 1);
    }
  }

  onCancel() {
    this.cancel.emit();
    this.closeModal();
  }

  onSelectAll() {
    this.addedConainersIndex = [];
    for(let i in this.containers) {
      this.addedConainersIndex = [...this.addedConainersIndex, Number(i)];
    }
  }

  closeModal() {
    this.addedConainersIndex = [];
    this.modalFileRef.close();
  }

  onAdd() {
    const data = sortBy(this.addedConainersIndex);
    this.add.emit(data.reverse());
    this.closeModal();
  }

  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
  }
}
